// Canonical "nothing selected" value for the multi-select header dropdown.
// Mirrors the shape the Checkbox popover writes back into Formik so the
// header reads as un-checked and the bulk actions see no ids.
const EMPTY_SELECTION_STATE = { ids: {}, checked: false, select: null };

// Reset the `selected` field on the given Formik instance.
//
// Called when the user performs a search (or otherwise materially changes
// the underlying list): contacts/artworks/etc. selected against the
// previous result set are no longer visible and would silently sneak into
// bulk actions like Handover or Export, so we must wipe them as soon as the
// result set changes.
const clearSelectionState = formik => {
  formik?.setFieldValue?.("selected", EMPTY_SELECTION_STATE);
};

export { clearSelectionState, EMPTY_SELECTION_STATE };
